var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth__sign-up fill-height"},[_c('AuthSignUpCredentials',{attrs:{"sign-up-service":_vm.signUpService}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }